import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useModal } from 'mui-modal-provider';
import * as React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import DialogConfirmAction from '../../../components/Shared/DialogConfirmAction/DialogConfirmAction';
import useWindowResize from '../../../hooks/useWindowSize';
import { ApSchedulerBuildStage } from '../../../sic-lib/enums/ApSchedulerBuildStage';
import { resetCommunicatorState } from '../../../store/communicator';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import SectionContacts from '../SectionContacts/SectionContacts';
import SectionMessaging from '../SectionMessaging/SectionMessaging';
import Toolbar from '../Toolbar/Toolbar';

export default function Layout() {
    const { showModal } = useModal();
    const dispatch = useAppDispatch();

    const buildStage = useAppSelector(state => state.communicator.buildStage);

    React.useEffect(() => {
        if (buildStage === ApSchedulerBuildStage.complete) {
            const modal = showModal(DialogConfirmAction, {
                title: 'Campaign Scheduled',
                description: 'All messages scheduled',
                onConfirm: () => {
                    dispatch(resetCommunicatorState());
                },
                onCancel: () => {
                    modal.hide();
                },
            });
        }
    }, [buildStage, dispatch, showModal]);

    /*
        IMPORTANT: this is the screen size listener for the ApSchedulerPage component tree,
        only one should be active within the page at a time.
    */
    const { hasMediumScreen } = useWindowResize();

    const [pageLayout, setPageLayout] = React.useState<number>(0);

    const handleSetPageLayout = (event: React.ChangeEvent<{}>, newValue: number) => {
        if (!hasMediumScreen) {
            setPageLayout(newValue);
        }
    };

    return (
        <React.Fragment>
            <div className="apScheduler__page">
                {!hasMediumScreen && (
                    <Paper elevation={0} square className="apScheduler__tabs">
                        <Tabs
                            value={pageLayout}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            onChange={handleSetPageLayout}
                        >
                            <Tab label="Contacts" />
                            <Tab label="Messages" />
                        </Tabs>
                    </Paper>
                )}
                <div className="apScheduler__toolbar">
                    <Toolbar />
                </div>
                <TransitionGroup
                    component="div"
                    className="apScheduler__transitionWrapper"
                    appear={hasMediumScreen}
                >
                    <CSSTransition key={pageLayout} timeout={160}>
                        <div className="apScheduler__transition">
                            {(hasMediumScreen || pageLayout === 0) && <SectionContacts />}
                            {(hasMediumScreen || pageLayout === 1) && <SectionMessaging />}
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        </React.Fragment>
    );
}
